import React, { useState } from "react";
import galaxy from "../assets/images/galaxy.png";
import asstronuat from "../assets/images/asstronuat.png";
import styles from "../styles/app.module.scss";
import { Button } from "antd";
import {
  GlobalOutlined,
  CodeOutlined,
  HighlightOutlined,
  NumberOutlined,
  BgColorsOutlined,
} from "@ant-design/icons";
import classNames from "classnames";

export enum TabType {
  TAB_1 = "TAB_1",
  TAB_2 = "TAB_2",
  TAB_3 = "TAB_3",
  TAB_4 = "TAB_4",
  NOT_SELECT = "NOT_SELECT",
}

const About = () => {
  const [toggle_tab, setToggleTab] = useState<keyof typeof TabType>(
    TabType.TAB_1
  );
  // max-h-[100vh]
  // h-full max-h-[100vh] h-[calc(100vh - (148px))]
  return (
    <div className="flex flex-col justify-center py-[50px] ss:pt-0">
      <div className="flex flex-row gap-[50px] h-full sm:flex-col">
        <div className="w-[50%] sm:w-[100%] sm:order-2">
          <div className="relative ml-[40px] sm:ml-0 ">
            <p className="text-[26px] text-custom-gray-100 font-medium mt-[30px]">
              Welcome to my work space
            </p>
            <p className="text-custom-gray-75 max-w-[405px] text-sm">
              Hi!, this is the dave space, the land of creativity. You guys must
              have traveled very far, I'm guessing millions of light years.
              Well! In order not to lose a trip on this trip I'll show you my
              creations, let's go!
            </p>
          </div>

          {/* border-dashed border-[2px] border-y-[0px] border-r-[0px] border-custom-primary-75 */}
          <div className="mt-[45px] flex flex-col items-end mr-[20px] xs:mr-0 ">
            <h2 className="text-[32px] text-custom-gray-100 font-bold text-end">
              About me.
            </h2>

            <div className="w-full max-w-[470px] flex flex-col items-end gap-[15px]">
              <div
                className={classNames(
                  styles.typicalAbout,
                  {
                    [styles.activeAbout]: toggle_tab === TabType.TAB_1,
                  },
                  {
                    [styles.inactiveAbout]: toggle_tab !== TabType.TAB_1,
                  }
                )}
              >
                <div
                  className="flex items-center gap-[17px] cursor-pointer w-full"
                  onClick={() => setToggleTab(TabType.TAB_1)}
                >
                  <CodeOutlined
                    // className="text-[28px] text-custom-primary-100"
                    className={classNames(
                      "text-[22px] text-custom-primary-100",
                      {
                        ["text-custom-secondary-50"]:
                          toggle_tab === TabType.TAB_1,
                      },
                      {
                        ["text-custom-primary-100"]:
                          toggle_tab !== TabType.TAB_1,
                      }
                    )}
                  />
                  <h3
                    // className="text-xxl font-bold text-custom-gray-100"
                    className={classNames(
                      "text-xl font-bold text-custom-gray-100",
                      {
                        ["text-custom-secondary-75"]:
                          toggle_tab === TabType.TAB_1,
                      },
                      {
                        ["text-custom-gray-100"]: toggle_tab !== TabType.TAB_1,
                      }
                    )}
                  >
                    Front End Developer
                  </h3>
                </div>
                <p
                  // className="text-custom-gray-100 mt-[5px] mx-[10px] hidden"
                  className={classNames(
                    "text-custom-gray-100 mt-[5px] mx-[10px] text-sm",
                    {
                      ["block mt-[5px] mx-[10px"]: toggle_tab === TabType.TAB_1,
                    },
                    {
                      ["hidden mt-[0px] mx-[0px]"]:
                        toggle_tab !== TabType.TAB_1,
                    }
                  )}
                >
                  This is the current position I am working on. This allows the
                  UI look from the design to come true on a web app or mobile
                  app and create a work flow that users can understand perfectly
                  for a memorable user experience.
                </p>
              </div>

              <div
                className={classNames(
                  styles.typicalAbout,
                  {
                    [styles.activeAbout]: toggle_tab === TabType.TAB_2,
                  },
                  {
                    [styles.inactiveAbout]: toggle_tab !== TabType.TAB_2,
                  }
                )}
              >
                <div
                  className="flex items-center gap-[17px] cursor-pointer w-full"
                  onClick={() => setToggleTab(TabType.TAB_2)}
                >
                  <HighlightOutlined
                    // className="text-[28px] text-custom-primary-100"
                    className={classNames(
                      "text-[22px] text-custom-primary-100",
                      {
                        ["text-custom-secondary-50"]:
                          toggle_tab === TabType.TAB_2,
                      },
                      {
                        ["text-custom-primary-100"]:
                          toggle_tab !== TabType.TAB_2,
                      }
                    )}
                  />
                  <h3
                    // className="text-xxl font-bold text-custom-gray-100"
                    className={classNames(
                      "text-xl font-bold text-custom-gray-100",
                      {
                        ["text-custom-secondary-75"]:
                          toggle_tab === TabType.TAB_2,
                      },
                      {
                        ["text-custom-gray-100"]: toggle_tab !== TabType.TAB_2,
                      }
                    )}
                  >
                    Language Of Our Space
                  </h3>
                </div>

                <p
                  className={classNames(
                    "text-custom-gray-100 mt-[5px] mx-[10px] text-sm",
                    {
                      ["block mt-[5px] mx-[10px"]: toggle_tab === TabType.TAB_2,
                    },
                    {
                      ["hidden mt-[0px] mx-[0px]"]:
                        toggle_tab !== TabType.TAB_2,
                    }
                  )}
                >
                  <b>JavaScript</b> : It's versatile and continually innovates
                  to make coding fun and efficient.
                  <br />
                  <b>TypeScript</b> : a tool to help optimize JavaScript is even
                  more powerful. and help to improve the project even better
                </p>
              </div>

              <div
                className={classNames(
                  styles.typicalAbout,
                  {
                    [styles.activeAbout]: toggle_tab === TabType.TAB_3,
                  },
                  {
                    [styles.inactiveAbout]: toggle_tab !== TabType.TAB_3,
                  }
                )}
              >
                <div
                  className="flex items-center gap-[17px] cursor-pointer w-full"
                  onClick={() => setToggleTab(TabType.TAB_3)}
                >
                  <NumberOutlined
                    // className="text-[28px] text-custom-primary-100"
                    className={classNames(
                      "text-[22px] text-custom-primary-100",
                      {
                        ["text-custom-secondary-50"]:
                          toggle_tab === TabType.TAB_3,
                      },
                      {
                        ["text-custom-primary-100"]:
                          toggle_tab !== TabType.TAB_3,
                      }
                    )}
                  />
                  <h3
                    // className="text-xxl font-bold text-custom-gray-100"
                    className={classNames(
                      "text-xl font-bold text-custom-gray-100",
                      {
                        ["text-custom-secondary-75"]:
                          toggle_tab === TabType.TAB_3,
                      },
                      {
                        ["text-custom-gray-100"]: toggle_tab !== TabType.TAB_3,
                      }
                    )}
                  >
                    Dev tool
                  </h3>
                </div>
                <p
                  className={classNames(
                    "text-custom-gray-100 mt-[5px] mx-[10px] text-sm",
                    {
                      ["block mt-[5px] mx-[10px"]: toggle_tab === TabType.TAB_3,
                    },
                    {
                      ["hidden mt-[0px] mx-[0px]"]:
                        toggle_tab !== TabType.TAB_3,
                    }
                  )}
                >
                  <li>React JS</li>
                  <li>Next JS</li>
                  <li>Redux</li>
                  <li>Ant Design</li>
                  <li>Prisma</li>
                  <li>SCSS, Tailwind</li>
                  <li>Ant Design</li>
                  <li>Prisma</li>
                  <li>SCSS, Tailwind</li>
                </p>
              </div>

              <div
                className={classNames(
                  styles.typicalAbout,
                  {
                    [styles.activeAbout]: toggle_tab === TabType.TAB_4,
                  },
                  {
                    [styles.inactiveAbout]: toggle_tab !== TabType.TAB_4,
                  }
                )}
              >
                <div
                  className="flex items-center gap-[17px] cursor-pointer w-full"
                  onClick={() => setToggleTab(TabType.TAB_4)}
                >
                  <BgColorsOutlined
                    // className="text-[28px] text-custom-primary-100"
                    className={classNames(
                      "text-[22px] text-custom-primary-100",
                      {
                        ["text-custom-secondary-50"]:
                          toggle_tab === TabType.TAB_4,
                      },
                      {
                        ["text-custom-primary-100"]:
                          toggle_tab !== TabType.TAB_4,
                      }
                    )}
                  />
                  <h3
                    // className="text-xxl font-bold text-custom-gray-100"
                    className={classNames(
                      "text-xl font-bold text-custom-gray-100",
                      {
                        ["text-custom-secondary-75"]:
                          toggle_tab === TabType.TAB_4,
                      },
                      {
                        ["text-custom-gray-100"]: toggle_tab !== TabType.TAB_4,
                      }
                    )}
                  >
                    Creative
                  </h3>
                </div>
                <p
                  className={classNames(
                    "text-custom-gray-100 mt-[5px] mx-[10px] text-sm",
                    {
                      ["block mt-[5px] mx-[10px"]: toggle_tab === TabType.TAB_4,
                    },
                    {
                      ["hidden mt-[0px] mx-[0px]"]:
                        toggle_tab !== TabType.TAB_4,
                    }
                  )}
                >
                  <li>Figma</li>
                  <li>Adobe XD</li>
                  <li>Illustrator</li>
                  <li>Photoshop</li>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-[50%] sm:w-[100%] sm:order-1 ">
          <h1 className="text-[70px] font-bold tracking-[10px] text-custom-primary-100 mb-0 leading-[70px] z-50 md:text-[60px] ss:text-[30px] ss:text-center ss:mb-[-10px]">
            THE DAVE
          </h1>
          <p className="text-[25px] tracking-[62px] text-custom-gray-75 ml-[12px] md:text-[20px] ss:text-[14px] ss:text-center ss:tracking-[30px]  ">
            SPACE
          </p>
          <div
            className={classNames(
              styles.divImage,
              "sm:!h-[500px] ss:!h-[450px]"
            )}
          >
            <img src={galaxy} className={styles.galaxy} alt="galaxy" />
            <img src={asstronuat} className={styles.asstronuat} alt="galaxy" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
